exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".article-filter-ctn {\n  margin: 20px 0 10px;\n  padding: 0 12px;\n}\n\n.form-group.search-input {\n  padding: 0;\n}\n\n.search-input input {\n  width: 70%;\n}\n\n.form-group.select-input {\n  padding-left: 130px;\n}\n\n@media screen and (max-width: 544px) {\n  .form-group.select-input {\n    padding: 0;\n  }\n\n  .search-input input {\n    width: 100%;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/article-filter/article-filter.component.css
// module id = 374
// module chunks = 1